module.exports = "https://static.wanderu.com/static/media/usa-today-x2.1b7130b3.png";